import reverse from "./apps/reverse";
export default {
  reverse
};